// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none{display:none}.checkmark-usp-container{display:flex;align-items:center;grid-gap:4px;gap:4px;color:#2e2d2c}.checkmark-usp-container--cms{grid-gap:8px;gap:8px}.checkmark-usp-label{font-size:16px;font-weight:400;line-height:20px}.checkmark-usp-icon{color:#646363}.checkmark-usp-label div p{margin-bottom:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
